import React from 'react';
import classNames from 'classnames';
import './InboxSidebarNav.styl';
import Folder, {FolderId} from 'records/Folder';
import InboxFilters from 'records/InboxFilters';
import Button from '@material-ui/core/Button';
import {RouterLocation} from '@store/@types/util/ReactRouter';
import {makeStyles} from '@material-ui/core/styles';

interface InboxSidebarNavProps {
  onSelectFolder: (id: FolderId) => void;
  inbox: Folder;
  outbox: Folder;
  filters: InboxFilters;
  location: RouterLocation;
}

export function InboxSidebarNav(props: InboxSidebarNavProps) {
  const {onSelectFolder, inbox, outbox, filters} = props;
  const activeId = filters.folderId;
  const inboxActive = activeId === inbox.id;
  const outboxActive = activeId === outbox.id;
  const css = useStyles();
  return (
    <div className="admin-app-sidebar inbox-sidebar-nav">
      <div className="menu">
        <div className={classNames('link-container', {'child-active': inboxActive})}>
          <Button
            classes={css}
            className="link"
            fullWidth
            variant="text"
            onClick={() => onSelectFolder(inbox.id)}>
            Inbox
          </Button>
        </div>
        <div className={classNames('link-container', {'child-active': outboxActive})}>
          <Button
            classes={css}
            className="link"
            fullWidth
            variant="text"
            onClick={() => onSelectFolder(outbox.id)}>
            Outbox
          </Button>
        </div>
      </div>
    </div>
  );
}

const useStyles = makeStyles(theme => ({
  label: {
    justifyContent: 'flex-start',
  },
  root: {
    borderRadius: 0,
  },
}));
